import React from "react";
import { Layout } from "react-admin";
import "./CustomAdminLayout.css";

export default function CustomAdminLayout(props) {
    return <Layout {...props} className="admin-layout-root" />;
}